module.exports = __webpack_public_path__ + "static/media/logo.35c99dd4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/logo.svg
// module id = 108
// module chunks = 0